export const PATHS = {
    ROOT: 'pricing',
    CONDITIONS: 'conditions',
    PROCEDURES: 'procedures',
    PROMOTIONS: 'promotions',
}